module.exports = "/**\n * @Route(\"/movie/{movieId}\", name=\"movie\")\n */\npublic function movie(int $movieId)\n{\n    $em = $this->getDoctrine()->getManager();\n    \n    return $this->render('movies/movie.html.twig', [\n        'movie' => $em->getRepository(Movie::class)->findOneWithActors($movieId),\n    ]);\n}"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/pages/code/movie-controller-repo.txt
// module id = 650
// module chunks = 166022795811749